module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/step4-full-556f9f7f0c97570d1ffc498dfe486721.jpg";